import React, { useContext } from "react";
import Header from './Header';
import { ThemeContext } from "../context/themeContext";
import { AuthContext } from "../context/authContext";
import { ChatWidget } from "../components/Chat/ChatWidget";
import { PrivateChatWidget } from "../components/Chat/PrivateChatWidget";
import { usePrivateChat } from "../hooks/usePrivateChat";

export const Layout = ({ children }) => {
  const { theme } = useContext(ThemeContext);
  const { authState } = useContext(AuthContext);
  const privateChatProps = usePrivateChat(authState.isLoggedIn ? authState.sesion : null);

  return (
    <div className="Layout" data-theme={theme}>
      <Header />
      <div>{children}</div>
      <ChatWidget />
      <PrivateChatWidget {...privateChatProps} />
    </div>
  );
};
